module.exports = __webpack_public_path__ + "img/bentley_0.7949f601.png";